import {extendObservable} from 'mobx'
import firebase from '../firebase'
//TODO: import Logger from './Logger'
import {listModes} from '../containers/IdeaList'
import {listFilterModes} from '../stores/IdeaStore'
import {dueDateModes} from '../stores/IdeaStore'
import {majorModes} from '../containers/Header'

export const shareMode = Object.freeze({
    dontShare: 0,
    shareWithAdmins: 1,
    shareWithTeam: 2,
    noTeam: 3,
})

class PrefStore {
    constructor(authStore) {
        extendObservable(this, {
            viewMode: listModes.compact,
            majorMode: majorModes.ideas,
            ideaGroup: 'my',
            dashPref: 'owner,rec,image,teamSize,tags,stage,creationDate,lastUpdated,dueDate',
            compactPref: 'owner,rec,tags',
            cardPref: 'owner,rec,tags,desc,image',
            dashOrder: 'Stage',
            openSidebar: true,
            dueDateMode: dueDateModes.sortBy,
            listFilterMode: listFilterModes.allIdeas,
            storedListFilterMode: listFilterModes.allIdeas,
            listSearchText: '',
            storedListSearchText: '',
            lineColor: '#cccccc',
            showNonTeamIdeas: 3,
            showNonTeamStoredIdeas: 3,
            lineWidth: 3,
            defaultIdeaStages: [],
            defaultIdeaTools: [],
            defaultIdeaTags: [],
            teamMembers: [],
            teamUsers: null,
            teamAdmins: [],
            autoShare: 2,
            ideaTeam: null,
            loadedPrefs: false,
        })
        this.authStore = authStore

        this.unwatchAuth = authStore.watchAuth(user => {
            if(user){
                this.loadUserPreferences()
            }else{
                this.logout()
            }
        })
    }
    logout(){
    }
    loadUserPreferences(){
        const authUser = this.authStore.authUser()
        const prefRef = firebase.database().ref().child('users/'+authUser.uid).child('prefs')
        this.ideaTeam = null
        prefRef.on('value', snap => {
            if(!snap.exists())
            var res = {}
            if(snap.val() !== null)
                res = snap.val()
            this.ideaGroup = res.hasOwnProperty('ideaGroup') ? snap.val().ideaGroup : 'my'
            this.viewMode = res.hasOwnProperty('viewMode') ? snap.val().viewMode : listModes.compact
            if(this.viewMode===listModes.rich) //rich list have been removed
                this.viewMode=listModes.compact
            this.lineColor = res.hasOwnProperty('lineColor') ? snap.val().lineColor : '#cccccc'
            this.lineWidth = res.hasOwnProperty('lineWidth') ? snap.val().lineWidth : 3
            this.dashPref = res.hasOwnProperty('dashPref') ? snap.val().dashPref : 'owner,rec,image,teamSize,tags,stage,CreationDate,lastUpdated,dueDate'
            this.compactPref = res.hasOwnProperty('compactPref') ? snap.val().compactPref : 'owner,rec,tags'
            this.cardPref = res.hasOwnProperty('cardPref') ? snap.val().cardPref : 'owner,rec,tags,desc,image'
            this.dashOrder = res.hasOwnProperty('dashOrder') ? snap.val().dashOrder : 'Stage'
            this.majorMode = res.hasOwnProperty('majorMode') ? snap.val().majorMode : majorModes.ideas
            this.dueDateMode = res.hasOwnProperty('dueDateMode') ? snap.val().dueDateMode : dueDateModes.sortBy
            this.listFilterMode = res.hasOwnProperty('listFilterMode') ? snap.val().listFilterMode : listFilterModes.allIdeas
            this.listSearchText = res.hasOwnProperty('listSearchText') ? snap.val().listSearchText : ''
            this.storedListFilterMode = res.hasOwnProperty('storedListFilterMode') ? snap.val().storedListFilterMode : listFilterModes.allIdeas
            this.storedListSearchText = res.hasOwnProperty('storedListSearchText') ? snap.val().storedListSearchText : ''
            this.showNonTeamIdeas = res.hasOwnProperty('showNonTeamIdeas') ? snap.val().showNonTeamIdeas : 3
            this.showNonTeamStoredIdeas = res.hasOwnProperty('showNonTeamStoredIdeas') ? snap.val().showNonTeamStoredIdeas : 3
            this.defaultIdeaStages = []
            this.defaultIdeaTools = []
            this.loadedPrefs = true
            this.teamAdmins = []
        }, null, this)

    }
    findTeamAdmins(teamKey){
        let thing = this
        firebase.database().ref('teams/' + teamKey + '/admin').once('value').then(adminSnap => {
            if (adminSnap.exists()) {
                thing.teamAdmins = adminSnap.val()
            }
        })
    }
    findTeam(userId){
        let thing = this
        return new Promise((resolve, reject) => {
            firebase.database().ref('users/' + userId + '/primaryTeam').once('value').then(primaryTeamSnap => {
                if (primaryTeamSnap.exists()){
                    let primaryTeam = primaryTeamSnap.val()
                    this.findTeamAdmins(primaryTeam)
                    firebase.database().ref('teams/' + primaryTeam).once('value').then(teamSnap => {
                        if (teamSnap.exists()){
                            let team = teamSnap.val()
                            thing.ideaTeam = team
                            if(team.hasOwnProperty('stages')){
                                thing.defaultIdeaStages = team.stages
                            }else{
                                thing.defaultIdeaStages = []
                            }
                            if(team.hasOwnProperty('tags')){
                                thing.defaultIdeaTags = team.tags
                            }else{
                                thing.defaultIdeaTags = []
                            }
                            if(team.hasOwnProperty('tools')){
                                thing.defaultIdeaTools = team.tools
                            }else {
                                thing.defaultIdeaTools = []
                            }
                            if(team.hasOwnProperty('autoShare')){
                                thing.autoShare = team.autoShare
                            }else{
                                thing.autoShare = shareMode.dontShare
                            }
                            if(team.hasOwnProperty('members')){
                                thing.teamMembers = team.members
                                var users = []
                                let requests = Object.keys(thing.teamMembers).map((uid) => {
                                    return firebase.database().ref().child('users/' + uid).once('value').then(aUser => {
                                        users[uid] = aUser.val()
                                    })
                                })
                                Promise.all(requests).then(() => {
                                    let test = Object.entries(users)
                                    let UserArray = []
                                    test.forEach((element, index) => {
                                        UserArray[index] = test[index][1]
                                    })
                                    thing.teamUsers = UserArray
                                    resolve()
                                })
                            }else {
                                thing.teamMembers = []
                                resolve()
                            }
                        } else{
                            thing.ideaTeam = null
                            thing.autoShare = shareMode.noTeam
                            thing.defaultIdeaStages = []
                            thing.defaultIdeaTools = []
                            thing.teamMembers = []
                            thing.teamUsers = []
                            resolve()
                        }
                    })
                } else {
                    thing.ideaTeam = null
                    thing.autoShare = shareMode.noTeam
                    thing.defaultIdeaStages = []
                    thing.defaultIdeaTools = []
                    thing.teamMembers = []
                    thing.teamUsers = []
                    resolve()
                }
            })
        })
    }
    loadTeamPrefs(ideaKey){
        let thing = this
        return new Promise((resolve, reject) => {
            firebase.database().ref().child('ideas/'+ideaKey).once('value', snap => {
                // this.loadingSingleIdea = false //TODO: this is on the IdeaStore now, do we need it
                if(snap.exists()){
                    var idea = snap.val()
                    if(idea.hasOwnProperty('teamId')) {
                        this.findTeamAdmins(idea.teamId)
                        firebase.database().ref().child('teams/' + idea.teamId).on('value', function (teamSnap) {
                            if (teamSnap.exists()) {
                                let team = teamSnap.val()
                                thing.ideaTeam = team
                                if(team.hasOwnProperty('stages')){
                                    thing.defaultIdeaStages = team.stages
                                }else{
                                    thing.defaultIdeaStages = []
                                }
                                if(team.hasOwnProperty('tags')){
                                    thing.defaultIdeaTags = team.tags
                                }else{
                                    thing.defaultIdeaTags = []
                                }
                                if(team.hasOwnProperty('tools')){
                                    thing.defaultIdeaTools = team.tools
                                }else {
                                    thing.defaultIdeaTools = []
                                }
                                resolve()
                            }
                        })
                    }else{
                        thing.ideaTeam = null
                        thing.defaultIdeaStages = []
                        thing.defaultIdeaTools = []
                        thing.defaultIdeaTags = []
                        resolve()
                    }
                }
            })
        })
    }
    storeUserPreferences(){
        const authUser = this.authStore.authUser()
        if (this.majorMode === undefined){
            this.majorMode = majorModes.ideas
        }

        const prefRef = firebase.database().ref().child('users/'+authUser.uid).child('prefs')

        prefRef.set({
            viewMode: this.viewMode,
            lineColor: this.lineColor,
            lineWidth: this.lineWidth,
            dashPref: this.dashPref,
            compactPref: this.compactPref,
            cardPref: this.cardPref,
            dashOrder: this.dashOrder,
            majorMode: this.majorMode,
            ideaGroup: this.ideaGroup,
            dueDateMode: this.dueDateMode,
            listFilterMode: this.listFilterMode,
            listSearchText: this.listSearchText,
            storedListFilterMode: this.storedListFilterMode,
            storedListSearchText: this.storedListSearchText,
            showNonTeamIdeas: this.showNonTeamIdeas,
            showNonTeamStoredIdeas: this.showNonTeamStoredIdeas,
        })
    }
    storeUserIdeaGroup(theGroup){
        const authUser = this.authStore.authUser()
        firebase.database().ref('users/'+authUser.uid+'/prefs/ideaGroup').set(theGroup)
    }
}

export default PrefStore


// WEBPACK FOOTER //
// ./src/stores/PrefStore.js